module.exports = __webpack_public_path__ + "static/media/PHP_Plugins_IMG-Mobile.ab8c1d05.png";